import { Navigate } from "react-router-dom";
import { useAdminAuth } from "./AdminAuth";

export default function ProtectedRoute({ children }) {
  const { admin, ready } = useAdminAuth();
  if (!ready) {
    return <div className="grid min-h-screen place-items-center bg-[#f4f6fb] text-[#565b73]">Loading…</div>;
  }
  if (!admin) return <Navigate to="/admin/login" replace />;
  return children;
}
